import {ColumnsVisibilityMenu} from './ColumnsVisibilityMenu';
import {TOGGLEABLE_COLUMNS, type ColumnKey} from '../constants/listColumns';

interface Props {
	isVisible: (key: ColumnKey) => boolean;
	onToggle: (key: ColumnKey) => void;
}

/**
 * The ticket list's show/hide columns menu. Hidden below the lg breakpoint
 * (Tailwind lg = 1024px), as `hidden lg:block` did.
 */
export function ColumnsToggle({isVisible, onToggle}: Props) {
	return <ColumnsVisibilityMenu columns={TOGGLEABLE_COLUMNS} isVisible={isVisible} onToggle={onToggle} hideBelowPx={1024} />;
}
